import "./App.css";

import { Route, Routes, useNavigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import SignUp from "./pages/SignUp";
import Login from "./pages/Login";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import TemplesPage from "./pages/TemplesPage";
import PilgrimagePage from "./pages/PilgrimagePage";
import TempleDetailsPage from "./pages/TemplePage";
import NotFoundPage from "./pages/NotFoundPage";
import TempleForm from "./pages/admin/TempleForm";
import TempleList from "./pages/admin/TempleList";
import AdminLogin from "./pages/admin/AdminLogin";
import Dashboard from "./pages/admin/Dashboard";
import UserFavoritesPage from "./pages/UserFavoritesPage";
import ProfilePage from "./pages/ProfilePage";


function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/login" element={<Login />} />
      <Route path='/about' element={<AboutPage />} />
      <Route path='/contact' element={<ContactPage />} />
      <Route path="/temple" element={<TemplesPage />} />
      <Route path="/pilgrimage" element={<PilgrimagePage />} />
      <Route path="/temple/:id" element={<TempleDetailsPage />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/pages/UserFavoritesPage" element={<UserFavoritesPage />} />
      <Route path="/favorites" element={<UserFavoritesPage />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<TempleList />} />
      <Route path="/admin/temples" element={<TempleList />} />
      <Route path="/admin/temples/new" element={<TempleForm />} />
      <Route path="/admin/temples/edit/:id" element={<TempleForm />} />
      <Route path="" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;